import React, { Component } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Collapse } from 'react-collapse';
import Ingridient from '../../Common/Ingridient';
import Tag from './Tag';
import ArrowBackIcon from '../../../images/arrow-black.png';
import EditIcon from '../../../images/edit_icon.png';

export default class SingleDishItem extends Component {
  state = {
    isOpened: false,
  };

  open = () => {
    const { isOpened } = this.state;
    this.setState({ isOpened: !isOpened });
  };

  renderIngridientsList = () => {
    const {
      dish,
      dish: { recepie },
    } = this.props;
    // eslint-disable-next-line no-nested-ternary
    const ingridients = dish ? (recepie ? recepie.products : null) : null;
    if (ingridients) {
      return ingridients.map((ingridient) => (
        <Ingridient key={ingridient.id} ingridient={ingridient} />
      ));
    }
  };

  renderTagList = () => {
    const {
      dish: { tags },
    } = this.props;
    if (tags) return tags.map((tag) => <Tag key={tag.tag_id} tag={tag} />);
  };

  render() {
    const {
      dish,
      dish: { id, name, calories, avg_weight, recepie },
      editDish,
      confirmDeleting,
    } = this.props;
    const { isOpened } = this.state;
    return (
      <Item>
        <MainInfo>
          <Name onClick={this.open}>
            <ImgArrow src={ArrowBackIcon} alt="arrow" isOpened={isOpened} />
            {name}
            <EditButton to={`/dish/${id}/edit`} onClick={(event) => editDish(event, dish, false)}>
              <Img src={EditIcon} alt="edit" />
            </EditButton>
            <DeleteButton onClick={(event) => confirmDeleting(event, name, id)}>X</DeleteButton>
          </Name>
          <BlockForInfo>
            <InfoBlock>
              <InfoName>к</InfoName>
              <InfoValue>{calories >= 0 ? calories : null}</InfoValue>
            </InfoBlock>
            <InfoBlock>
              <InfoName>б</InfoName>
              <InfoValue>{recepie ? recepie.proteins : null}</InfoValue>
            </InfoBlock>
            <InfoBlock>
              <InfoName>ж</InfoName>
              <InfoValue>{recepie ? recepie.fats : null}</InfoValue>
            </InfoBlock>
            <InfoBlock>
              <InfoName>у</InfoName>
              <InfoValue>{recepie ? recepie.carbohydrates : null}</InfoValue>
            </InfoBlock>
            <WeightBlock>
              <InfoName>Среднаяя порция/грамм</InfoName>
              <InfoValue>{avg_weight}</InfoValue>
            </WeightBlock>
          </BlockForInfo>
        </MainInfo>
        <Collapse isOpened={isOpened}>
          <RecepieBlock>
            <Recepie>
              <Title>Рецепт</Title>
              {recepie ? recepie.text : null}
            </Recepie>
            <IngridientList>
              <Title>Ингредиенты на 100г. блюда:</Title>
              {dish ? this.renderIngridientsList() : null}
            </IngridientList>
            <Tags>
              <Title>Теги</Title>
              {this.renderTagList()}
            </Tags>
          </RecepieBlock>
        </Collapse>
      </Item>
    );
  }
}

const Item = styled.div`
  width: 100%;
  margin: 15px auto;
  box-sizing: border-box;
  border: 2px solid #c1c1c1;
  border-radius: 5px;
  box-shadow: 3px 3px 2px #afafaf;
`;

const MainInfo = styled.div`
  width: 100%;
  height: 80px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  background: #fff;
  border-bottom: 1px solid #c1c1c1;
  @media (max-width: 992px) {
    flex-direction: column;
    height: auto;
  }
`;

const Name = styled.div`
  position: relative;
  cursor: pointer;
  width: 40%;
  height: 100%;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  padding: 0 90px 0 50px;
  border-right: 1px solid #c1c1c1;
  @media (max-width: 992px) {
    height: 80px;
    width: 100%;
    word-wrap: break-word;
    border-right: none;
    border-bottom: 1px solid #c1c1c1;
  }
  @media (max-width: 600px) {
    height: auto;
    align-items: flex-start;
    padding: 20px 20px 65px;
  }
`;

const ImgArrow = styled.img`
  position: absolute;
  left: 10px;
  bottom: 25px;
  width: 30px;
  height: 30px;
  transition: 0.3s;
  transform: ${(props) => (props.isOpened ? 'rotate(270deg)' : 'rotate(90deg)')};
`;

const DeleteButton = styled.div`
  position: absolute;
  width: 30px;
  height: 30px;
  right: 10px;
  bottom: 25px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  background: #db2828;
  color: #fff;
  border: none;
  border-radius: 5px;
  &:hover {
    background: #d01919;
    border: 1px solid #000542;
  }
  @media (max-width: 600px) {
    right: 25px;
  }
`;

const EditButton = styled(Link)`
  position: absolute;
  width: 30px;
  height: 30px;
  bottom: 25px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #fff;
  border: none;
  border-radius: 5px;
  right: 50px;
  border: 1px solid #000542;
  background: #fff;
  &:hover {
    background: #17ade3;
    border: 1px solid #000542;
  }
  @media (max-width: 600px) {
    right: 70px;
  }
`;

const Img = styled.img`
  width: 20px;
  height: 20px;
`;

const BlockForInfo = styled.div`
  display: flex;
  width: 60%;
  height: 100%;
  @media (max-width: 992px) {
    height: 80px;
    width: 100%;
  }
`;

const InfoBlock = styled.div`
  width: 15%;
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
  border-right: 1px solid #c1c1c1;
`;

const WeightBlock = InfoBlock.extend`
  width: 40%;
  border: none;
`;

const InfoValue = styled.div`
  height: 50%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;
`;

const InfoName = InfoValue.extend`
  border-bottom: 1px solid #c1c1c1;
  background: #e8e8e8;
`;

const RecepieBlock = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  @media (max-width: 768px) {
    flex-flow: column nowrap;
  }
`;

const Recepie = styled.div`
  box-sizing: border-box;
  width: 45%;
  padding: 15px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const IngridientList = Recepie.extend`
  width: 35%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Tags = Recepie.extend`
  width: 20%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Title = styled.h3`
  margin: 0 0 15px 0;
`;



// WEBPACK FOOTER //
// ./src/Components/Dishes/DishesList/SingleDishItem.jsx